import React from 'react';
import PropTypes from 'prop-types';

import Popper from '@mui/material/Popper';
import {Grow, Paper, ClickAwayListener} from 'views/components';

const CustomPopper = (props) => {
  const {
    children,
    open,
    onClickAway,
    anchorEl,
    disablePortal,
    GrowSx,
    placement,
    popperModifiers,
    zIndex,
  } = props;

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      transition
      disablePortal={disablePortal}
      placement={placement}
      modifiers={popperModifiers}
      sx={{zIndex}}
    >
      {({TransitionProps, placement}) => (
        <Grow
          {...TransitionProps}
          sx={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            ...GrowSx,
          }}
        >
          <Paper >
            <ClickAwayListener onClickAway={onClickAway}>
              {children}
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
CustomPopper.propTypes = {
  open: PropTypes.bool.isRequired,
  onClickAway: PropTypes.func.isRequired,
  anchorEl: PropTypes.any,
  disablePortal: PropTypes.bool,
  GrowSx: PropTypes.object,
  children: PropTypes.node,
  placement: PropTypes.string,
  popperModifiers: PropTypes.array,
  zIndex: PropTypes.number,
};

export default CustomPopper;
